import { useAtom } from 'jotai';

import { useEffect, useState } from 'react';
import { View } from '../CommonTypes';
import { storageUrl } from '../firebase';
import { showCompassOptionsAtom } from '../states/planner';
import CompassCameraButton from './CompassCameraButton';
import CompassApartmentHighlight from './CompassApartmentHighlight';
import { useOverviewSVG } from '../hooks/useCameraSVG';

export const CompassOptions = ({
  siteViews,
  overviewPicture,
  overviewPictureSVG,
}: {
  siteViews: View[];
  overviewPicture: string;
  overviewPictureSVG: string;
}) => {
  const [viewBox, svgPaths] = useOverviewSVG(overviewPictureSVG);
  const [showCompassOptions, setShowCompassOptions] = useAtom(showCompassOptionsAtom);
  const viewNames = siteViews.map(view => view.viewname);
  const [imgDimRatio, setImgDimRatio] = useState(1);

  useEffect(() => {
    const img = new Image();
    img.src = overviewPicture;
    img.onload = () => {
      setImgDimRatio(img.naturalHeight / img.naturalWidth);
    };
  }, [overviewPicture]);

  const getDivPosition = () => {
    if (imgDimRatio === 1) {
      return 'top-[2%] h-[60%] w-[60%] left-[20%] sm:top-[29%] sm:left-[28%] sm:h-[44%] sm:w-[44%] min-[420px]:top-[7%] min-[420px]:left-[20%] min-[420px]:h-[60%] min-[420px]:w-[60%]';
    } else {
      return 'top-[10%] h-[70%] w-[70%] left-[15%] sm:top-[43%] sm:left-[28%] sm:h-[44%] sm:w-[44%] min-[420px]:top-[15%]';
    }
  };

  if (!showCompassOptions) return null;

  return (
    <>
      <div
        className={`absolute left-0 top-0 h-full w-full cursor-default ${showCompassOptions ? 'visible' : 'invisible'}`}
        role="button"
        tabIndex={0}
        onKeyDown={e => e.key === 'Enter' && setShowCompassOptions(false)}
        onClick={() => setShowCompassOptions(false)}
      ></div>

      <div
        className={`absolute left-[15%] ${getDivPosition()} cursor-default opacity-90 ${
          showCompassOptions ? 'visible scale-100 opacity-100' : 'invisible scale-90 opacity-0'
        }`}
      >
        <div className="relative inline-block">
          <img alt="ViewImage" src={storageUrl(overviewPicture)} className="block h-auto max-w-full rounded-md" />
          {viewBox && svgPaths && (
            <svg className="absolute left-0 top-0" viewBox={`${viewBox}`} preserveAspectRatio="none">
              {svgPaths.map(l => {
                if (l.type == 'view') {
                  return (
                    <CompassCameraButton
                      key={l.ref_id}
                      coordinates={l.coordinates}
                      slide={viewNames.indexOf(l.ref_id)}
                      ref_id={l.ref_id}
                      active={showCompassOptions}
                    />
                  );
                } else if (l.type == 'apartment') {
                  return (
                    <CompassApartmentHighlight
                      key={l.ref_id}
                      apartmentIdsStr={l.ref_id}
                      d={l.coordinates}
                      toolTipPlace={l.tooltipplace}
                      toolTipId={'apartment-tooltip'}
                    />
                  );
                }
              })}
            </svg>
          )}
        </div>
      </div>
    </>
  );
};
